import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

// Attach bearer token as a fallback for environments where cookies fail (Safari, etc.)
api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? localStorage.getItem("gcs_token") : null;
  if (token) {
    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
  }
  return config;
});

export const LOGO_FALLBACK =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_rosas-cleaning-web/artifacts/3ga4ui35_223060.png";
